import { RequiredTheme, ResponsiveValue, system, Theme } from 'styled-system';
import * as CSS from 'csstype';

export const objectPosition = system({
    objectPosition: true,
});

export interface ObjectPositionProps<ThemeType extends Theme = RequiredTheme> {
    objectPosition?: ResponsiveValue<CSS.Property.ObjectPosition, ThemeType> | undefined;
}
